import React from 'react'
import { t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'

export const DeleteJobSeekerModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <DeleteResourceModal
    alert={t`You are about to delete this person.`}
    message={t`Are you sure you want to delete?`}
    title={t`Delete person`}
    {...{ onCancel, onClose, onConfirm, isOpen }}
  />
)
